import {Component, Input} from '@angular/core';
import {Platform} from "@angular/cdk/platform";


@Component({
  selector: 'pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrl: './pdf-preview.component.scss'
})
export class PdfPreviewComponent {
  @Input() public pathPdf: string
  @Input() public style: string

  constructor(protected platform: Platform) {
  }
}
